export default function tabsHandler() {
	const tabsContainers = document.querySelectorAll('.js-tabs');

	tabsContainers.forEach(container => {
		const tabsNav = container.querySelector('.js-tabs-nav');
		const tabsLinks = tabsNav.querySelectorAll('.js-tabs-link');
		const tabsSections = container.querySelectorAll('.js-tabs-section');

		if (tabsLinks.length > 0 && tabsSections.length > 0) {
			tabsLinks[0].classList.add('is-active');

			const firstTargetId = tabsLinks[0].getAttribute('data-target');
			const firstTargetSection = container.querySelector(`#tab-${firstTargetId}`);

			if (firstTargetSection) {
				firstTargetSection.classList.add('is-active');
			}
		}

		tabsLinks.forEach(link => {
			link.addEventListener('click', (e) => {
				e.preventDefault();

				const targetId = link.getAttribute('data-target');
				const targetSection = container.querySelector(`#tab-${targetId}`);

				tabsLinks.forEach(link => link.classList.remove('is-active'));
				tabsSections.forEach(section => section.classList.remove('is-active'));

				link.classList.add('is-active');
				if (targetSection) {
					targetSection.classList.add('is-active');
				}
			});
		});
	});
}